<template>
    <Teleport to="#bsdc-modals">
        <Transition name="fade">
            <div
                v-show="active"
                :id="id"
                class="bsdc:size-full bsdc:fixed bsdc:top-0 bsdc:l-0 bsdc:z-40"
            >
                <div class="bsdc:size-full bsdc:fixed bsdc:top-0 bsdc:left-0 bsdc:z-40">
                    <div
                        class="bsdc:size-full bsdc:absolute bsdc:top-0 bsdc:left-0 bsdc:opacity-50"
                        :class="{
                            'bsdc:bg-black': wash,
                        }"
                        @click="emit('close')"
                    ></div>

                    <div
                        data-modal-content
                        class="bsdc:size-full bsdc:flex"
                        :class="{
                            'bsdc:justify-end': version === 1,
                            'bsdc:justify-center bsdc:items-center-safe': version === 2,
                        }"
                    >
                        <div
                            class="bsdc:w-full bsdc:max-h-full bsdc:flex bsdc:flex-col bsdc:relative bsdc:overflow-y-auto bsdc:bg-white bsdc:shadow-xl bsdc:pt-0"
                            :class="{
                                'bsdc:max-w-[480px] bsdc:p-5': version === 1,
                                'bsdc:max-w-[440px] bsdc:rounded-lg bsdc:p-7': version === 2,
                            }"
                        >
                            <div
                                class="bsdc:flex bsdc:items-center"
                                :class="{
                                    'bsdc:py-4 bsdc:sm:py-5 bsdc:border-b bsdc:border-2-1': version === 1,
                                    'bsdc:pt-7': version === 2,
                                }"
                            >
                                <h2
                                    v-if="title"
                                    class="bsdc:heading bsdc:text-lg"
                                    v-text="title"
                                ></h2>
                                <button
                                    class="bsdc:size-4 bsdc:bg-brand-50 bsdc:rounded-full bsdc:flex bsdc:items-center bsdc:justify-center button-secondary bsdc:ml-auto bsdc:hover:opacity-50 bsdc:transition-opacity"
                                    @click.prevent="emit('close')"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="currentColor"
                                        class="bsdc:size-4 bsdc:sm:size-6"
                                    >
                                        <path
                                            class="uuid-85294d59-618f-46cc-8e05-2a662aced03c"
                                            d="M15.5,16c-.12793,0-.25586-.04883-.35352-.14648L.14648.85352C-.04883.6582-.04883.3418.14648.14648S.6582-.04883.85352.14648l15,15c.19531.19531.19531.51172,0,.70703-.09766.09766-.22559.14648-.35352.14648Z"
                                        />
                                        <path
                                            class="uuid-85294d59-618f-46cc-8e05-2a662aced03c"
                                            d="M.5,16c-.12793,0-.25586-.04883-.35352-.14648-.19531-.19531-.19531-.51172,0-.70703L15.14648.14648c.19531-.19531.51172-.19531.70703,0s.19531.51172,0,.70703L.85352,15.85352c-.09766.09766-.22559.14648-.35352.14648Z"
                                        />
                                    </svg>
                                </button>
                            </div>

                            <div :class="{
                                'bsdc:pt-6 bsdc:sm:pt-8': version === 1,
                                'bsdc:pt-6': version === 2,
                            }">
                                <slot />
                            </div>

                            <div
                                v-if="$slots.footer"
                                class="bsdc:mt-auto bsdc:-mb-5 bsdc:py-4 bsdc:sm:py bsdc:sticky bsdc:-bottom-5 bsdc:bg-white bsdc:border-t bsdc:border-2-1 bsdc:z-50"
                            >
                                <slot name="footer" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Transition>
    </Teleport>
</template>

<script setup>
    defineProps({
        active: Boolean,
        id: String,
        title: String,
        wash: {
            type: Boolean,
            default: true,
        },
        version: {
            type: Number,
            default: 1,
        },
    });

    const emit = defineEmits(["close"]);
</script>
